import { privateApi } from '../ApiService';
import { OtysCandidateByIdResponse, OtysCandidateByOuidResponse } from './types';

const fetchOtysCandidateByOuid = async (candidateOuid: string): Promise<OtysCandidateByIdResponse> => {
    const { otysCandidateId } = await privateApi.get<OtysCandidateByOuidResponse>(
        `otys/candidate-by-ouid/${candidateOuid}`,
    );

    return privateApi.get<OtysCandidateByIdResponse>(`otys/candidate/${otysCandidateId}`);
};

export const OtysCandidateGateway = {
    fetchOtysCandidateByOuid,
};
